import * as React from "react";
import IconButton from "@material-ui/core/IconButton/";
import DeleteIcon from "@material-ui/icons/DeleteForeverTwoTone";
import ApplicationStatusMessageDeleteConfirmationModal from "./ApplicationStatusMessageDeleteConfirmationModal";

type State = {
  showModal: boolean;
};

type Props = {
  statusMessage: any;
};

export default class ApplicationStatusMessageDeleteContainer extends React.Component<
  Props,
  State
> {
  state = {
    showModal: false,
  };

  onCloseModal = () => {
    this.setState({ showModal: !this.state.showModal });
  };

  render() {
    return (
      <React.Fragment>
        <IconButton
          key="delete"
          color="primary"
          onClick={() => {
            this.setState({
              showModal: true,
            });
          }}
        >
          <DeleteIcon />
        </IconButton>
        {this.state.showModal && (
          <ApplicationStatusMessageDeleteConfirmationModal
            statusMessage={this.props.statusMessage}
            onClose={this.onCloseModal}
          />
        )}
      </React.Fragment>
    );
  }
}
